import type { IAddress } from 'contexts/Addresses';

export function displayAddress(address: IAddress): string {
  const {
    addressName = '',
    addressStreet = '',
    postcodeArea = '',
    postcodeDistrict = '',
  } = address || {};

  return [addressName, addressStreet, `${postcodeArea} ${postcodeDistrict}`]
    .filter((item) => item.trim())
    .join(', ');
}
